import { useAppContext, ErrorItem } from "../contexts/AppContext";

export function addErrorEntry(errors: ErrorItem[], newError: ErrorItem): ErrorItem[] {
    return [...errors, newError];
}

export function removeErrorByKey(errors: ErrorItem[], keyToRemove: string): ErrorItem[] {
    return errors.filter((error) => error.key !== keyToRemove);
}

export function getErrorMessage(errors: ErrorItem[], key: string): string | undefined {
    const error = errors.find((err) => err.key === key);
    return error?.message;
}
